import React, { PureComponent } from 'react';
import { View } from 'react-native';

import { createContainer } from '@dbk-legacy/muster/react';

import styles from './info-message.styles';

class InfoMessage extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
   const {error}=this.props;
     return(<div className="row info-message info-message-ch">
        <div className="column small-12 text-center">
          <div className="error-block">
            <span>{error}</span>
          </div>
        </div>
      </div>);

  }
}

export default InfoMessage;

